import { render, staticRenderFns } from "./DisclosureComponent.vue?vue&type=template&id=098c0d84&scoped=true"
import script from "./DisclosureComponent.vue?vue&type=script&lang=js"
export * from "./DisclosureComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098c0d84",
  null
  
)

export default component.exports